import { Component } from "@angular/core";

@Component({
    selector: 'app-versatile-list',
    templateUrl: './versatile-list.component.html',
    styleUrls: ['./versatile-list.component.scss']
})
export class VersatileListComponent {

}
